import React from "react";
import styles from "./ProgramBlog.module.css";
import Image from "next/image";
import Link from "next/link";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

interface BlogData {
  id: number;
  title: string;
  category: string;
  date: string;
  reading_time: string;
  url: string;
  image: {
    url: string;
    name: string;
    width: number;
    height: number;
  }[];
}

interface ProgramBlogProps {
  data?: BlogData[];
}

const ProgramBlog: React.FC<ProgramBlogProps> = ({ data = [] }) => {
  const hasSlider = (data?.length || 0) > 3;

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Insights and Highlights</h2>

      {hasSlider ? (
        <div className={styles.swiperContainer}>
          <Swiper
            slidesPerView={3}
            spaceBetween={24}
            modules={[Pagination]}
            pagination={{ clickable: true, type: "bullets" }}
            className={styles.swiperStyle}
            breakpoints={{
              320: { slidesPerView: 1, spaceBetween: 16 },
              768: { slidesPerView: 2, spaceBetween: 20 },
              992: { slidesPerView: 3, spaceBetween: 24 },
              1200: { slidesPerView: 3, spaceBetween: 24 },
            }}
          >
            {data?.map((blog) => (
              <SwiperSlide key={blog?.id} className={styles.swiperSlide}>
                <div className={styles.blogCard}>
                  <Link
                    href={blog?.url}
                    title={blog?.image[0]?.name || blog?.title}
                  >
                    <Image
                      src={blog?.image[0]?.url}
                      alt={blog?.image[0]?.name || blog?.title}
                      title={blog?.image[0]?.name || blog?.title}
                      className={styles.blogImage}
                      width={blog?.image[0]?.width || 500}
                      height={blog?.image[0]?.height || 300}
                    />
                    <div className={styles.blogContent}>
                      <span className={styles.category}>{blog?.category}</span>
                      <h3 className={styles.title}>{blog?.title}</h3>
                      <div className={styles.meta}>
                        <span>{blog?.date}</span> •{" "}
                        <span>{blog?.reading_time}</span>
                      </div>
                    </div>
                  </Link>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      ) : (
        <div className={styles.blogGrid}>
          {data?.map((blog) => (
            <div key={blog?.id} className={styles.blogCard}>
              <Link
                href={blog?.url}
                title={blog?.image[0]?.name || blog?.title}
              >
                <Image
                  src={blog?.image[0]?.url}
                  alt={blog?.image[0]?.name || blog?.title}
                  title={blog?.image[0]?.name || blog?.title}
                  className={styles.blogImage}
                  width={blog?.image[0]?.width || 500}
                  height={blog?.image[0]?.height || 300}
                />
                <div className={styles.blogContent}>
                  <span className={styles.category}>{blog?.category}</span>
                  <h3 className={styles.title}>{blog?.title}</h3>
                  <div className={styles.meta}>
                    <span>{blog?.date}</span> •{" "}
                    <span>{blog?.reading_time}</span>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProgramBlog;
